import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import Button from '../../components/elements/button';
import { Search, Filter, Lab, Doctor } from '../../assets/icons';
import '../../assets/css/pages/cases.css';
import { useNavigate } from 'react-router-dom';
import NewCaseModal from '../../components/aquadoc/newCase';
import { casesApi } from '../../network/apis/cases';
import LoadingSpinner from '../../components/elements/LoadingSpinner';
import { farmsApi } from '../../network/apis/farms';
// import { Stats, Calendar, Warning } from '../../assets/icons';

const Cases = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        status: 'all',
        type: 'all',
        date: 'all'
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    const [activeFilters, setActiveFilters] = useState(0);
    const [showNewCaseForm, setShowNewCaseForm] = useState(false);
const [farms, setFarms] = useState([]);
const [cases, setCases] = useState([]);


    // Add debounced search
    const debouncedSearch = debounce((searchTerm) => {
        setSearchTerm(searchTerm);
    }, 300);

    const handleSearch = (e) => {
        debouncedSearch(e.target.value);
    };

    const clearFilters = () => {
        setFilters({
            status: 'all',
            type: 'all',
            date: 'all'
        });
    };

    useEffect(() => {
        // Count active filters
        fetchCases();
        fetchFarms();
        const activeCount = Object.values(filters).filter(value => value !== 'all').length;
        setActiveFilters(activeCount);
    }, [filters]);

    const fetchCases = async () => {
            try {
                setLoading(true);
                const response = await casesApi.getMyCases();
            console.log(response);
            // Handle paginated response
            if (response.data) {
                setCases(response.data);
            } else {
                setCases([]);
            }
        } catch (error) {
            setError(error.message || 'Failed to fetch cases');
            setCases([]);
        } finally {
            setLoading(false);
        }
        };

    const fetchFarms = async () => {
        try {
            setLoading(true);
            const response = await farmsApi.getFarms();
            if (response.data) {
                setFarms(response.data);
            } else {
                setFarms([]);
            }
        } catch (error) {
            setError(error.message || 'Failed to fetch farms');
            setFarms([]);
        } finally {
            setLoading(false);
        }
    };

const handleCaseClick = (caseId) => {
    navigate(`/cases/${caseId}`, {state:{case:cases.find(c => c.id === caseId)}});

};

const handleNewCase = () => {
    setShowNewCaseForm(true);
};
  

    const filteredCases = cases.filter(item => {
        return item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
               item.description.toLowerCase().includes(searchTerm.toLowerCase());
    });


const CasesTable = ({ cases, onCaseClick }) => {

    if (loading) {
        return <LoadingSpinner />;
    }

    if (error) {
        return (
            <div className="error-container">
                <h2>Something went wrong</h2>
                <p>{error}</p>
                <Button 
                    text="Try Again" 
                    variant="primary" 
                    onClick={fetchCases}
                />
            </div>
        );
    }
    return (
        <div className="cases-table-container">
            <table className="cases-table">
                <thead>
                    <tr>
                        <th>S/N</th>
                        <th>Title</th>
                        <th>Status</th>
                        <th>Priority</th>
                        <th>Assigned To</th>
                        <th>Lab Results</th>
                        {/* <th>Farm</th> */}
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {cases.map(caseItem => (
                        <tr 
                            key={caseItem.id} 
                            onClick={() => onCaseClick(caseItem.id)}
                            className={`priority-${caseItem.priority}`}
                        >
                            <td className="case-id">{caseItem.id}</td>
                            <td className="case-title">
                                <div>
                                    <h4>{caseItem.title}</h4>
                                    <p>{caseItem.description}</p>
                                </div>
                            </td>
                            <td>
                                <span className={`status-badge ${caseItem.status.toLowerCase()}`}>
                                    {caseItem.status}
                                </span>
                            </td>
                            <td>
                                <span className={`priority-badge ${caseItem.priority.toLowerCase()}`}>
                                    {caseItem.priority}
                                </span>
                            </td>
                            <td className="assigned-to">
                                {caseItem.assignedTo ? (
                                    <div className="assigned-info">
                                        <img 
                                            src={caseItem.assignedTo.type === 'doctor' ? Doctor : Lab} 
                                            className="icon" 
                                            alt={caseItem.assignedTo.type}
                                        />
                                        <span>{caseItem.assignedTo.name}</span>
                                    </div>
                                ) : (
                                    <span className="unassigned">Unassigned</span>
                                )}
                            </td>
                            <td className="lab-results">
                                <span className={`lab-badge ${caseItem.labResults === 'Pending' ? 'pending' : ''}`}>
                                    {caseItem.labResults}
                                </span>
                            </td>
                            {/* <td>{caseItem.farm}</td> */}
                            <td>{new Date(caseItem.created_at).toLocaleDateString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

CasesTable.propTypes = {
    cases: PropTypes.array.isRequired,
    onCaseClick: PropTypes.func.isRequired
};
    
    // Update your return statement to include the dashboard section
    // Update your return statement to include the dashboard section
    return (
        <div className="cases-page">
            <div className="cases-header">
                <h1>Fish Farm Health Cases</h1>
                <div className="header-actions">
                    <Button 
                        onClick={() => handleNewCase()}
                        text="Report New Case"
                        variant="primary"
                    />
                </div>
            </div>
            <div className={`search-bar ${isSearchFocused ? 'focused' : ''}`}>
                <img src={Search} className="search-icon" alt="search" />
                <input 
                    type="text"
                    placeholder="Search cases..."
                    onChange={handleSearch}
                    onFocus={() => setIsSearchFocused(true)}
                    onBlur={() => setIsSearchFocused(false)}
                />
                {searchTerm && (
                    <button 
                        className="clear-search" 
                        onClick={() => setSearchTerm('')}
                        aria-label="Clear search"
                    >
                        ×
                    </button>
                )}
            </div>

            <div className="filters-section">
                <div className="filters-header">
                    <img src={Filter} alt="" className="filter-icon" />
                    <span>Filters</span>
                    {activeFilters > 0 && (
                        <span className="filter-count">{activeFilters}</span>
                    )}
                </div>

                <div className="filters-group">
                    <select 
                        value={filters.status}
                        onChange={(e) => setFilters({...filters, status: e.target.value})}
                        className={filters.status !== 'all' ? 'active' : ''}
                    >
                        <option value="all">Status: All</option>
                        <option value="open">Open</option>
                        <option value="in-progress">In Progress</option>
                        <option value="resolved">Resolved</option>
                    </select>

                    <select 
                        value={filters.type}
                        onChange={(e) => setFilters({...filters, type: e.target.value})}
                        className={filters.type !== 'all' ? 'active' : ''}
                    >
                        <option value="all">Type: All</option>
                        <option value="doctor">Doctor Assigned</option>
                        <option value="lab">Lab Analysis</option>
                    </select>

                    <select 
                        value={filters.date}
                        onChange={(e) => setFilters({...filters, date: e.target.value})}
                        className={filters.date !== 'all' ? 'active' : ''}
                    >
                        <option value="all">Date: All Time</option>
                        <option value="today">Today</option>
                        <option value="week">This Week</option>
                        <option value="month">This Month</option>
                    </select>

                    {activeFilters > 0 && (
                        <button 
                            className="clear-filters"
                            onClick={clearFilters}
                        >
                            Clear All
                        </button>
                    )}
                </div>
            </div>

            <CasesTable 
            cases={filteredCases} 
            onCaseClick={handleCaseClick}
            />

            {showNewCaseForm && <NewCaseModal cases={cases} setCases={setCases} setShowNewCaseForm={setShowNewCaseForm} farms={farms} />}
        </div>
    );
};

export default Cases;